import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/market-insights.svg";
var MarketInsightsOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  MarketInsightsOutline_default as default
};
